import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = { class: "form-menu" };
const _hoisted_4 = { class: "float-end" };
const _hoisted_5 = { class: "form-contents" };
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { class: "clearfix" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_9 = { class: "input-group top_search" };
const _hoisted_10 = { class: "input-group-btn" };
const _hoisted_11 = { class: "col-xs-12 col-sm-12 col-md-8" };
const _hoisted_12 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12"
};
const _hoisted_13 = { class: "clearfix data-grid-top-pagination" };
const _hoisted_14 = { class: "float-end left5" };
const _hoisted_15 = { class: "clearfix pad10" };
const _hoisted_16 = { class: "float-end" };
const _hoisted_17 = {
    key: 0,
    class: "float-end"
};
const _hoisted_18 = { class: "float-end hidden-xs record-count" };
const _hoisted_19 = { class: "col-xs-12 col-sm-12" };
const _hoisted_20 = { class: "card bg-white data-grid companies-grid detached overflow-x-auto" };
const _hoisted_21 = { class: "table table-hover bottom0 pw100" };
const _hoisted_22 = { key: 0 };
const _hoisted_23 = {
    key: 1,
    class: "hidden-sm"
};
const _hoisted_24 = {
    key: 2,
    class: "hidden-sm"
};
const _hoisted_25 = {
    key: 3,
    class: "hidden-sm"
};
const _hoisted_26 = {
    key: 4,
    class: "hidden-sm"
};
const _hoisted_27 = {
    key: 5,
    class: "hidden-sm"
};
const _hoisted_28 = { class: "text-center hidden-sm" };
const _hoisted_29 = { key: 0 };
const _hoisted_30 = { class: "clearfix visible-sm" };
const _hoisted_31 = { class: "clearfix" };
const _hoisted_32 = { class: "float-start right5" };
const _hoisted_33 = { class: "float-start" };
const _hoisted_34 = {
    key: 1,
    class: "hidden-sm"
};
const _hoisted_35 = {
    key: 2,
    class: "hidden-sm"
};
const _hoisted_36 = {
    key: 3,
    class: "hidden-sm"
};
const _hoisted_37 = {
    key: 4,
    class: "hidden-sm"
};
const _hoisted_38 = {
    key: 5,
    class: "hidden-sm"
};
const _hoisted_39 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_router_link = _resolveComponent("router-link");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_form_group = _resolveComponent("b-form-group");
    const _component_b_dropdown_form = _resolveComponent("b-dropdown-form");
    const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
    const _component_b_button_group = _resolveComponent("b-button-group");
    const _directive_standard_or_higher = _resolveDirective("standard-or-higher");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "form-title" }, [
                _createElementVNode("h2", null, "\r\n\t\t\t\t\tCompanies\r\n\t\t\t\t")
            ], -1 /* CACHED */)),
            _cache[6] || (_cache[6] = _createTextVNode()),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    (!_ctx.isClientAdministrator)
                        ? _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: { name: 'company' }
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_b_button, { variant: "primary" }, {
                                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                            _createElementVNode("span", { class: "fa fa-plus" }, null, -1 /* CACHED */),
                                            _createElementVNode("span", { class: "hidden-xs" }, " Add Company", -1 /* CACHED */)
                                        ]))]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })), [
                            [_directive_standard_or_higher]
                        ])
                        : _createCommentVNode("v-if", true)
                ])
            ])
        ]),
        _cache[54] || (_cache[54] = _createTextVNode()),
        _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_b_form_input, {
                                type: "text",
                                modelValue: _ctx.query.keywords,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                                modelModifiers: { trim: true },
                                placeholder: "Search for...",
                                onKeyup: _withKeys(_ctx.search, ["enter"]),
                                required: ""
                            }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                            _cache[8] || (_cache[8] = _createTextVNode()),
                            _createElementVNode("span", _hoisted_10, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-default",
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.search && _ctx.search(...args)))
                                }, [...(_cache[7] || (_cache[7] = [
                                        _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* CACHED */)
                                    ]))])
                            ])
                        ])
                    ]),
                    _cache[20] || (_cache[20] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_11, [
                        (_ctx.searchAttempted)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, [
                                        _createVNode(_component_b_dropdown, {
                                            ref: "columnSettingsDropdown",
                                            "no-caret": "",
                                            end: "",
                                            sm: "",
                                            "auto-close": false,
                                            variant: "outline-secondary outline-secondary-pagination",
                                            disabled: _ctx.working
                                        }, {
                                            "button-content": _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                                    _createElementVNode("i", { class: "fa fa-cog" }, null, -1 /* CACHED */)
                                                ]))]),
                                            default: _withCtx(() => [
                                                _cache[15] || (_cache[15] = _createTextVNode()),
                                                _createVNode(_component_b_dropdown_form, { class: "column-settings-dropdown" }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_b_form_group, null, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_b_form_checkbox, {
                                                                    id: "includeDeleted",
                                                                    modelValue: _ctx.query.includeDeleted,
                                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.query.includeDeleted) = $event))
                                                                }, {
                                                                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tShow archived\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                        ]))]),
                                                                    _: 1 /* STABLE */
                                                                }, 8 /* PROPS */, ["modelValue"])
                                                            ]),
                                                            _: 1 /* STABLE */
                                                        }),
                                                        _cache[11] || (_cache[11] = _createTextVNode()),
                                                        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "clearfix top10" }, [
                                                            _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tColumn visibility\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                        ], -1 /* CACHED */)),
                                                        _cache[13] || (_cache[13] = _createTextVNode()),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, columnIdx) => {
                                                            return (_openBlock(), _createBlock(_component_b_form_group, {
                                                                key: column.fieldName
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_b_form_group, null, {
                                                                        default: _withCtx(() => [
                                                                            _createVNode(_component_b_form_checkbox, {
                                                                                id: column.fieldName,
                                                                                modelValue: column.visible,
                                                                                "onUpdate:modelValue": ($event) => ((column.visible) = $event)
                                                                            }, {
                                                                                default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(column.title), 1 /* TEXT */)
                                                                                ]),
                                                                                _: 2 /* DYNAMIC */
                                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "modelValue", "onUpdate:modelValue"])
                                                                        ]),
                                                                        _: 2 /* DYNAMIC */
                                                                    }, 1024 /* DYNAMIC_SLOTS */)
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1024 /* DYNAMIC_SLOTS */));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }),
                                                _cache[16] || (_cache[16] = _createTextVNode()),
                                                _createVNode(_component_b_dropdown_divider),
                                                _cache[17] || (_cache[17] = _createTextVNode()),
                                                _createElementVNode("div", _hoisted_15, [
                                                    _createElementVNode("div", _hoisted_16, [
                                                        _createVNode(_component_b_button, {
                                                            variant: "secondary",
                                                            right: "",
                                                            sm: "",
                                                            onClick: _ctx.closeColumnSettingsMenu
                                                        }, {
                                                            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                                                    _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                                                    _createTextVNode(" Close\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                ]))]),
                                                            _: 1 /* STABLE */
                                                        }, 8 /* PROPS */, ["onClick"])
                                                    ])
                                                ])
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["disabled"])
                                    ]),
                                    _cache[18] || (_cache[18] = _createTextVNode()),
                                    (_ctx.numberOfVisibleColumns)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                            _createVNode(_component_b_pagination, {
                                                class: "float-end",
                                                modelValue: _ctx.query.pageNo,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.query.pageNo) = $event)),
                                                "per-page": _ctx.query.pageSize,
                                                "total-rows": _ctx.data.recordCount,
                                                "hide-ellipsis": true,
                                                disabled: _ctx.working
                                            }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[19] || (_cache[19] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_18, "\r\n\t\t\t\t\t\t\t\t\tItems: " + _toDisplayString(_ctx.data.recordCount), 1 /* TEXT */)
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _cache[53] || (_cache[53] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("table", _hoisted_21, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _cache[21] || (_cache[21] = _createElementVNode("th", { class: "text-center hidden-sm w40 no-min-width" }, null, -1 /* CACHED */)),
                                    _cache[22] || (_cache[22] = _createTextVNode()),
                                    (_ctx.isVisible('companyName'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_22, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'CompanyName', title: 'Name' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[23] || (_cache[23] = _createTextVNode()),
                                    (_ctx.isVisible('streetAddress3'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_23, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'StreetAddress3', title: 'City' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[24] || (_cache[24] = _createTextVNode()),
                                    (_ctx.isVisible('streetAddress4'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_24, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'StreetAddress4', title: 'State' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[25] || (_cache[25] = _createTextVNode()),
                                    (_ctx.isVisible('countryName'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_25, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'CountryName', title: 'Country' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[26] || (_cache[26] = _createTextVNode()),
                                    (_ctx.isVisible('companyCode'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_26, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'CompanyCode', title: 'Ref' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[27] || (_cache[27] = _createTextVNode()),
                                    (_ctx.isVisible('accountCombinedStatus'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_27, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'AccountStatus', title: 'Account Status' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ]),
                            _cache[51] || (_cache[51] = _createTextVNode()),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        class: _normalizeClass({ 'deleted': item.whenDeleted })
                                    }, [
                                        _createElementVNode("td", _hoisted_28, [
                                            _createVNode(_component_b_button_group, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_dropdown, {
                                                        variant: "outline-secondary dots",
                                                        size: "sm",
                                                        onClick: ($event) => (_ctx.edit(item))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.edit(item))
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                                                        _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* CACHED */),
                                                                        _createTextVNode(" Edit\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                    ]))]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["onClick"]),
                                                            _cache[31] || (_cache[31] = _createTextVNode()),
                                                            _createVNode(_component_b_dropdown_divider),
                                                            _cache[32] || (_cache[32] = _createTextVNode()),
                                                            _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.archive(item))
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                                                        _createElementVNode("span", { class: "fa fa-trash" }, null, -1 /* CACHED */),
                                                                        _createTextVNode(" Archive\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                    ]))]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["onClick"]), [
                                                                [_vShow, !_ctx.isClientAdministrator && !item.whenDeleted]
                                                            ]),
                                                            _cache[33] || (_cache[33] = _createTextVNode()),
                                                            _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.restore(item))
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                                                                        _createElementVNode("span", { class: "fa fa-refresh" }, null, -1 /* CACHED */),
                                                                        _createTextVNode(" Restore\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                    ]))]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["onClick"]), [
                                                                [_vShow, !_ctx.isClientAdministrator && item.whenDeleted]
                                                            ])
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        _cache[44] || (_cache[44] = _createTextVNode()),
                                        (_ctx.isVisible('companyName'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_29, [
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'company', params: { 'id': item.companyId } },
                                                    class: "blue hidden-sm"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item.companyName), 1 /* TEXT */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                                                _cache[43] || (_cache[43] = _createTextVNode()),
                                                _createElementVNode("div", _hoisted_30, [
                                                    _createVNode(_component_router_link, {
                                                        to: { name: 'company', params: { 'id': item.companyId } },
                                                        class: "lead"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(item.companyName), 1 /* TEXT */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                                                    _cache[42] || (_cache[42] = _createTextVNode()),
                                                    _createElementVNode("div", _hoisted_31, [
                                                        _withDirectives(_createElementVNode("div", { class: "clearfix" }, _toDisplayString(item.companyTypeName), 513 /* TEXT, NEED_PATCH */), [
                                                            [_vShow, item.companyTypeName]
                                                        ]),
                                                        _cache[39] || (_cache[39] = _createTextVNode()),
                                                        _withDirectives(_createElementVNode("div", null, [
                                                            _withDirectives(_createElementVNode("div", _hoisted_32, [
                                                                _cache[34] || (_cache[34] = _createElementVNode("i", { class: "fa fa-phone" }, null, -1 /* CACHED */)),
                                                                _createTextVNode(" " + _toDisplayString(item.phone), 1 /* TEXT */)
                                                            ], 512 /* NEED_PATCH */), [
                                                                [_vShow, item.phone]
                                                            ]),
                                                            _cache[36] || (_cache[36] = _createTextVNode()),
                                                            _createElementVNode("div", _hoisted_33, [
                                                                _withDirectives(_createElementVNode("span", null, [
                                                                    _cache[35] || (_cache[35] = _createElementVNode("i", { class: "fa fa-envelope-o" }, null, -1 /* CACHED */)),
                                                                    _createTextVNode(" " + _toDisplayString(item.emailAddress), 1 /* TEXT */)
                                                                ], 512 /* NEED_PATCH */), [
                                                                    [_vShow, item.email]
                                                                ])
                                                            ])
                                                        ], 512 /* NEED_PATCH */), [
                                                            [_vShow, item.phone || item.emailAddress]
                                                        ]),
                                                        _cache[40] || (_cache[40] = _createTextVNode()),
                                                        _withDirectives(_createElementVNode("div", null, [
                                                            _cache[37] || (_cache[37] = _createElementVNode("i", { class: "fa fa-map-marker" }, null, -1 /* CACHED */)),
                                                            _createTextVNode(" " + _toDisplayString(_ctx.getCombinedAddress(item)), 1 /* TEXT */)
                                                        ], 512 /* NEED_PATCH */), [
                                                            [_vShow, item.primaryAddressId]
                                                        ]),
                                                        _cache[41] || (_cache[41] = _createTextVNode()),
                                                        _createElementVNode("div", null, [
                                                            _cache[38] || (_cache[38] = _createElementVNode("i", { class: "fa fa-info-circle" }, null, -1 /* CACHED */)),
                                                            _createTextVNode(" " + _toDisplayString(_ctx.getAccountCombinedStatus(item)), 1 /* TEXT */)
                                                        ])
                                                    ])
                                                ])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _cache[45] || (_cache[45] = _createTextVNode()),
                                        (_ctx.isVisible('streetAddress3'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_34, _toDisplayString(item.streetAddress3), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _cache[46] || (_cache[46] = _createTextVNode()),
                                        (_ctx.isVisible('streetAddress4'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_35, _toDisplayString(item.streetAddress4), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _cache[47] || (_cache[47] = _createTextVNode()),
                                        (_ctx.isVisible('countryName'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_36, _toDisplayString(item.countryName), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _cache[48] || (_cache[48] = _createTextVNode()),
                                        (_ctx.isVisible('companyCode'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_37, _toDisplayString(item.companyCode), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _cache[49] || (_cache[49] = _createTextVNode()),
                                        (_ctx.isVisible('accountCombinedStatus'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_38, _toDisplayString(_ctx.getAccountCombinedStatus(item)), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true)
                                    ], 2 /* CLASS */));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ]),
                            _cache[52] || (_cache[52] = _createTextVNode()),
                            _createElementVNode("tfoot", null, [
                                (_ctx.noData)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_39, [...(_cache[50] || (_cache[50] = [
                                            _createElementVNode("td", {
                                                class: "text-center",
                                                colspan: "6"
                                            }, [
                                                _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
                                            ], -1 /* CACHED */)
                                        ]))]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.searchAttempted]
                ])
            ])
        ])
    ]));
}
